import React from 'react'
import {  Navigate, Outlet, useNavigate } from 'react-router-dom';
import SidebarAdmin from '../../components/admin/SidebarAdmin';
import AllRoutes from '../../nametitle/AllRoutes';
import { Localvalue } from '../../nametitle/localValue';

const NavbarAdmin = () => {

    const navigate =  useNavigate();
    var accesstoken = sessionStorage.getItem(Localvalue.access);
    if (accesstoken == null) {
        return <Navigate to={`/${AllRoutes.login}`} />
    }
    else {
        return (
            <div className="relative w-full">
                
                <div className="  w-full flex flex-row">
                    <div className="">
                        <SidebarAdmin />
                    </div>
                    <div className="w-full bg-light">
                        <Outlet />
                    </div>
                </div>
            </div>
        )
    }

}

export default NavbarAdmin;
